var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conecta-atenciones__base" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 m12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm11: "",
                    layout: "",
                    wrap: "",
                    "ma-4": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "" } },
                    [
                      _c("DatePicker", {
                        attrs: { label: "Fecha Creación Inicio", max: _vm.now },
                        model: {
                          value: _vm.objParam.start_date,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "start_date", $$v)
                          },
                          expression: "objParam.start_date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "" } },
                    [
                      _c("DatePicker", {
                        attrs: { label: "Fecha Creación Fin", max: _vm.now },
                        model: {
                          value: _vm.objParam.end_date,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "end_date", $$v)
                          },
                          expression: "objParam.end_date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nombre Baja",
                          clearable: "",
                          "prepend-icon": "find_in_page"
                        },
                        model: {
                          value: _vm.objParam.nombre_baja,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "nombre_baja", $$v)
                          },
                          expression: "objParam.nombre_baja"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Cliente",
                          items: _vm.filterApi.clientes,
                          "item-text": "cliente",
                          "item-value": "rut",
                          clearable: "",
                          "prepend-icon": "apartment"
                        },
                        model: {
                          value: _vm.objParam.rut,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "rut", $$v)
                          },
                          expression: "objParam.rut"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Estado Conecta",
                          items: _vm.filterApi.estados,
                          "item-text": "configvalor",
                          "item-value": "configid",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.configid,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "configid", $$v)
                          },
                          expression: "objParam.configid"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Tramo Baja",
                          items: _vm.filterApi.tramos,
                          "item-text": "nombre_tramo",
                          "item-value": "nombre_tramo",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          density: "compact",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.tipo_tramo,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "tipo_tramo", $$v)
                          },
                          expression: "objParam.tipo_tramo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Razón Estado CRM",
                          items: _vm.filterApi.razones_estado,
                          "item-text": "razon_estado",
                          "item-value": "razon_estado",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          density: "compact",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.razon_estado,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "razon_estado", $$v)
                          },
                          expression: "objParam.razon_estado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Estado CRM",
                          items: _vm.filterApi.estados_crm,
                          "item-text": "estado_crm",
                          "item-value": "estado_crm",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          density: "compact",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.estado_crm,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "estado_crm", $$v)
                          },
                          expression: "objParam.estado_crm"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Motivo de Baja",
                          items: _vm.filterApi.motivos,
                          "item-text": "motivo_baja_crm",
                          "item-value": "motivo_baja_crm",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.motivo_baja,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "motivo_baja", $$v)
                          },
                          expression: "objParam.motivo_baja"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Situación Baja",
                          items: _vm.filterApi.situacion_baja,
                          "item-text": "nombre_situcion_baja",
                          "item-value": "nombre_situcion_baja",
                          clearable: "",
                          "prepend-icon": "home_repair_service",
                          multiple: "",
                          chips: ""
                        },
                        model: {
                          value: _vm.objParam.situacion_baja,
                          callback: function($$v) {
                            _vm.$set(_vm.objParam, "situacion_baja", $$v)
                          },
                          expression: "objParam.situacion_baja"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm3: "",
                        layout: "",
                        "justify-center": "",
                        "align-center": "",
                        wrap: "",
                        "ma-0": "",
                        "pa-0": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleSearchFilter } },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.reloadGrid({ clear: true })
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                layout: "",
                "justify-end": "",
                "align-center": "",
                "mt-3": "",
                "mb-4": "",
                wrap: ""
              }
            },
            [
              _vm.permiso_boton
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "#ffe800" },
                      on: { click: _vm.handleClickAsignarTramo }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("add_circle_outline")
                      ]),
                      _vm._v(" Asignar Tramos\n      ")
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getCSV("")
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar"),
                    _c("br")
                  ])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getCSV("Detalle")
                    }
                  }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar Detalle Serie"),
                    _c("br")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "" } },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  funcionalidadId: _vm.funcionalidad,
                  verCheckbox: true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogPopUp,
          titulo: _vm.confirmationData.title,
          mensaje: _vm.confirmationData.msgConfirmation,
          textoBtnSi: _vm.$t("Confirmar"),
          textoBtnNo: _vm.$t("Cancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleShowPopUp($event)
          }
        }
      }),
      _vm.showModalViewDetail
        ? _c("BajasComercialesModalVerDetalle", {
            attrs: {
              data: _vm.data,
              esEdicion: _vm.showModalEdit,
              bajaFinalizada: _vm.bajaFinalizada,
              tramos: _vm.filterApi.tramos
            },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e(),
      _vm.dialogAsignarTramo
        ? _c("BajasComercialesAsignarTramo", {
            attrs: { objParam: _vm.objParam, dataList: _vm.dataListSelected },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }